import { SettingsIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { generatePath, Link } from 'react-router';

import CreateButton from '@/components/common/CreateButton';
import MainTabs from '@/components/common/MainTabs';
import { Button } from '@/components/shadcn/button';
import useDistributionLogo from '@/hooks/useDistributionLogo';
import paths from '@/lib/paths';

export default function Header() {
  const { t } = useTranslation();

  const logo = useDistributionLogo();

  return (
    <div className="flex flex-col">
      <span className="fixed top-0 right-0" data-onboarding-id="pin-sidebar" />

      <div className="flex items-center justify-center border-b p-1">
        <div className="flex min-w-0 flex-1 items-center gap-2">
          {logo && (
            <img
              src={logo}
              alt={t('DISTRIBUTION_LOGO_ALT')}
              className="h-7 max-w-24 shrink-0 object-contain"
              onError={(e) => {
                // Hide the logo if it fails to load
                e.currentTarget.style.display = 'none';
              }}
            />
          )}
        </div>

        <div className="flex items-center gap-1">
          <CreateButton />

          <Button
            variant="ghost"
            size="icon-sm"
            title={t('SETTINGS_MENU')}
            asChild
          >
            <Link to={generatePath(paths.settings)}>
              <SettingsIcon className="h-3.5 w-3.5" />

              <span className="sr-only">{t('SETTINGS_MENU')}</span>
            </Link>
          </Button>
        </div>
      </div>

      <MainTabs />
    </div>
  );
}
